module.exports = __webpack_public_path__ + "static/media/dummy-content-1.28240057.svg";